import { Component, computed, OnDestroy, Signal, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  ClearRegisterBusinessDetails,
  ClearRegisterDetails,
  GoToStep,
} from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { RegistrationDataModel } from '../../../../_interfaces/registration_response.interface';
import { OnboardingSelectors } from '../../../../store/onboarding/onboarding.selectors';
import { RegisterService } from '../../../../_services/register-service/register.service';
import { ResendBtnComponent } from '../../../../shared/components/resend-btn/resend-btn.component';
import { Observable } from 'rxjs';
import { RouterSwitchBtnComponent } from '../../../../shared/components/router-switch-btn/router-switch-btn.component';
import { VerifyAccountResponse } from '../../../../_interfaces/verify-account';

@Component({
  selector: 'app-verify-email',
  imports: [ResendBtnComponent, RouterSwitchBtnComponent],
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent implements OnDestroy {
  readonly store = inject(Store);
  readonly registerService = inject(RegisterService);

  data?: RegistrationDataModel;
  emailSentText: string = "We've sent a verification email";
  private readonly signup: Signal<string> = computed(
    () => <string>this.store.selectSnapshot(OnboardingSelectors.registerDetails)?.id,
  );
  resend$: Observable<VerifyAccountResponse>;

  constructor() {
    this.store.dispatch(new GoToStep(OnboardingSteps.VERIFY_EMAIL));
    this.store.select(OnboardingSelectors.registerDetails).subscribe({
      next: (res) => {
        this.data = res;
        this.emailSentText = `We've sent a verification email to ${this.data?.email}`;
      },
    });
    this.resend$ = this.registerService.resendEmail(this.signup());
  }

  emailResend() {
    this.emailSentText = `Verification email resent to (${this.data?.email})`;
  }

  ngOnDestroy(): void {
    this.store.dispatch(new ClearRegisterDetails());
    this.store.dispatch(new ClearRegisterBusinessDetails());
  }
}
